module.exports = __webpack_public_path__ + "static/main_logo_white-7d0cadc0c1e8eb66582d2c5f112cb11a.svg";